module.exports = __webpack_public_path__ + "static/media/popupteste.2d36793c.png";